import { ReservationElement as Reservation } from "@/models/responses";

/**
 * Split a (pre-sorted) reservation list into active bookings and cancellations,
 * preserving the incoming order within each group. Cancelled reservations are
 * surfaced in their own report section AFTER the bookings rather than
 * interleaved among them, so an owner can see at a glance that there were
 * cancellations. A missing `isCancelled` flag counts as an active booking.
 */
export function partitionReservations(reservations: Reservation[]): {
    bookings: Reservation[];
    cancellations: Reservation[];
} {
    const bookings: Reservation[] = [];
    const cancellations: Reservation[] = [];
    for (const reservation of reservations) {
        (reservation.isCancelled ? cancellations : bookings).push(reservation);
    }
    return { bookings, cancellations };
}
